// removed by extract-text-webpack-plugin
module.exports = {"seoHeading":"Dp6Zx","seoSubHeading":"TN6YB"};